import { ActionIcon, LogsIcon } from "../Icon";

export const OrdersActionCellItems = ({ onActionClick, onLogsClick }) => {
  return [
    {
      component: ActionIcon,
      onClick: onActionClick,
      name: "Actions",
    },
    {
      component: LogsIcon,
      onClick: onLogsClick,
      name: "Logs",
    },
  ];
};
